import HistoricoModificacao from '@/components/form/historico-modificacao'
import FinancialTable from '../simples-nacional/tabela-simples'
import ListaBoletos from '@/components/form/boleto/listar-boletos'
import ResumoSimples from '../simples-nacional/resumos.-simples'
import ProductDashboard from '../producto-dashboard'
import InfoSimples from '../simples-nacional/info-simples'
import { PageLayout } from '@/layouts'
import { useFetchApuracaoByIdProduct } from '../../services/useFetchApuracaoByIdProduct'
import { Loader2 } from 'lucide-react'

import { useApuracaoSelecionada } from '../../hooks/seApuracaoSelecionada'
import { useEffect } from 'react'
import { ProdutosStatus } from '@/lib/enums'
import { Product } from '../../state/selectProduct'
import { useCurrentUser } from '@/features/auth/state/auth'

type simplesProps = {
  cnpj?: string
  product: Product
}

export default function SimplesNacional({ cnpj, product }: simplesProps) {
  const { data: apuracoes = [], isLoading } = useFetchApuracaoByIdProduct(product?.id ?? '')
  const { apuracaoSelecionada, setApuracaoSelecionada } = useApuracaoSelecionada()
  const user = useCurrentUser()
  console.log('SimplesNacional - apuracoes:', apuracoes)
  console.log('SimplesNacional - apuracaoSelecionada:', apuracaoSelecionada)
  useEffect(() => {
    if (apuracoes.length > 0 && !apuracaoSelecionada) {
      setApuracaoSelecionada(apuracoes[0])
    }
  }, [apuracoes])

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-96 z-50">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
      </div>
    )
  }
  if (!apuracaoSelecionada) {
    return <p>Nenhuma apuração encontrada.</p>
  }
  return (
    <PageLayout title="Simples Nacional" showSidebarTrigger={false}>
      <ResumoSimples id_apuracao={apuracaoSelecionada.id} />
      <ProductDashboard
        clientInfo={{
          parceiro: product.parceiro,
          empresa: product.empresa,
          nomeAnalista: product.nomeAnalista,
          status: ProdutosStatus[product.status] ?? product.status
        }}
        cnpj={cnpj ?? ''}
        productId={product.id}
        type="PIS_COFINS_MONOFASICO_PARA_SN"
        apuracoes={apuracoes}
        selectedApuracao={apuracaoSelecionada}
      />
      <InfoSimples product={product} cnpj={cnpj || ``} />
      {user?.typeUser === 'ADMIN' && <FinancialTable />}

      <HistoricoModificacao type="PIS_COFINS_MONOFASICO_PARA_SN" productId={product.id} />
      <ListaBoletos cnpj={cnpj} />
    </PageLayout>
  )
}
